<!-- <app-switcher></app-switcher> -->

<router-outlet></router-outlet>
